import { useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useAttioValuationContext } from 'dashboard409a/context/AttioValuationContext';
import { useCompanyMeasurementDateByAttioValuationId } from 'dashboard409a/hooks/useCompanyMeasurementDateByAttioValuationId';
import { useFulfillmentList } from 'dashboard409a/services/fulfillment';
import AnalystNotesHistoryPanel from './AnalystNotesHistoryPanel';
import { Container, StyledTab, StyledTabs } from './NotesDisplay.styles';
import NoteTabPanel from './NoteTabPanel';
import { Section } from '../Section';

const NotesDisplay = ({ isFromModels }: { isFromModels: boolean }) => {
  const [value, setValue] = useState(isFromModels ? 1 : 0);

  const { currentAttioValuation } = useAttioValuationContext();
  const valuationId = currentAttioValuation?.valuedInformation.valuationId;

  const {
    data: companyMeasurementDateByAttioId,
    isLoading: isCompanyMeasurementDateLoading,
  } = useCompanyMeasurementDateByAttioValuationId(valuationId);

  const appCompanyId = useMemo(() => {
    const companyId = companyMeasurementDateByAttioId?.company?.id;
    return companyId ? companyId.toString() : undefined;
  }, [companyMeasurementDateByAttioId?.company?.id]);

  const { data: fulfillmentData } = useFulfillmentList(appCompanyId);

  const existingFulfillmentId = useMemo(() => {
    if (!fulfillmentData?.results || !companyMeasurementDateByAttioId?.id) {
      return undefined;
    }

    return (
      fulfillmentData.results.find(
        f => f.company_measurement_date === companyMeasurementDateByAttioId.id
      )?.id ?? undefined
    );
  }, [fulfillmentData?.results, companyMeasurementDateByAttioId?.id]);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Section title="">
      <Container>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs 
            value={value} 
            onChange={handleChange}
            aria-label="notes display tabs"
          >
            <StyledTab label="Valuation Notes" id="notes-display-tab-0" aria-controls="notes-display-tabpanel-0" />
            <StyledTab label="Model Support Notes" id="notes-display-tab-1" aria-controls="notes-display-tabpanel-1" />
          </StyledTabs>
        </Box>
        <NoteTabPanel value={value} index={0}>
          <AnalystNotesHistoryPanel
            referenceType="at"
            referenceId={valuationId}
            isDisabled={!valuationId || isCompanyMeasurementDateLoading}
          />
        </NoteTabPanel>
        <NoteTabPanel value={value} index={1}>
          <AnalystNotesHistoryPanel
            referenceType="fu"
            referenceId={existingFulfillmentId}
            isDisabled={!existingFulfillmentId}
          />
        </NoteTabPanel>
      </Container>
    </Section>
  );
};

export default NotesDisplay;
